// Tested
export const toggleClass = (element: HTMLElement, classToToggle: string) => {
	if (element.classList.contains(classToToggle)) {
		element.classList.remove(classToToggle);
	} else {
		element.classList.add(classToToggle);
	}
};
